/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidationStatsStatusesInner
 */
export interface ValidationStatsStatusesInner {
    /**
     * 
     * @type {string}
     * @memberof ValidationStatsStatusesInner
     */
    status: ValidationStatsStatusesInnerStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ValidationStatsStatusesInner
     */
    count: number;
}


/**
 * @export
 */
export const ValidationStatsStatusesInnerStatusEnum = {
    Validated: 'validated',
    Pending: 'pending',
    Review: 'review',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;
export type ValidationStatsStatusesInnerStatusEnum = typeof ValidationStatsStatusesInnerStatusEnum[keyof typeof ValidationStatsStatusesInnerStatusEnum];


/**
 * Check if a given object implements the ValidationStatsStatusesInner interface.
 */
export function instanceOfValidationStatsStatusesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ValidationStatsStatusesInnerFromJSON(json: any): ValidationStatsStatusesInner {
    return ValidationStatsStatusesInnerFromJSONTyped(json, false);
}

export function ValidationStatsStatusesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationStatsStatusesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'count': json['count'],
    };
}

export function ValidationStatsStatusesInnerToJSON(value?: ValidationStatsStatusesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'count': value.count,
    };
}

